module.exports = __webpack_public_path__ + "img/dialog_img.cb9a22a0.png";